import { Elements } from '@kontent-ai/delivery-sdk'
import {
	DomHtmlNode,
	DomNode,
	parseHTML,
	toHTML,
	transformToPortableText,
} from '@kontent-ai/rich-text-resolver'
import { ReactNode } from 'react'
import slugify from 'slugify'

const getDomNodeText = (node: DomNode): string => {
	if (!node) return ''
	if (node.type === 'text') return node.content || ''
	const children = (node as DomHtmlNode).children
	if (Array.isArray(children)) return children.map(getDomNodeText).join('')
	return ''
}
const Heading = ({
	as,
	id,
	children,
}: {
	as: string
	id: string
	children: ReactNode
}) => {
	const Tag = as as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	return <Tag id={id}>{children}</Tag>
}

export const getRichtextElementHeadingsReact = (
	richTextElement: Elements.RichTextElement,
): JSX.Element[] => {
	const portableText = transformToPortableText(richTextElement.value)
	const html = toHTML(portableText)

	return parseHTML(html)
		.map((item: DomNode) => {
			const isHeading = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(
				item['tagName'],
			)
			if (item.type === 'tag' && isHeading) {
				const _item: DomHtmlNode = item
				const text = getDomNodeText(_item)
				const id = slugify(text, { lower: true })

				return (
					<Heading
						as={_item.tagName}
						id={id || ''}
						{..._item.attributes}
					>
						{text}
					</Heading>
				)
			}
			return null
		})
		.filter(Boolean)
}
